import React from 'react';
import Web3 from 'web3';
import axios from 'axios';
import { withRouter, Link } from 'react-router-dom';

import { SupportedTokens, SwapContracts, SwapContractABI } from "../../Data/ContractData";
import SwapOrderBox from '../../Components/SwapOrderBox/SwapOrderBox';


import "./home.css";


class Home extends React.Component {

  /*
    tokenSelected
    0 : APIX
    1 : wDASH
    2 : wXZC
  */

  constructor(props) {
    super(props);

    this.state = {
      isMetamaskConnected: false,
      userAccount: "",

      tokenSelectboxOpened: [false, false],
      tokenSelected: [0, 1],
      tokenAmount: [0, 0],

      swapSearchResult: [],
      searchedSwapPair: 0,

      tokenPriceList: ["N/A", "N/A", "N/A"],
    }
  }

  web3 = null;

  tokenInfo = [
    {
      tokenName: "APIX",
      tokenIcon: "tokenicon_apix.svg"
    },
    {
      tokenName: "WETH",
      tokenIcon: "tokenicon_weth.svg"
    },
    {
      tokenName: "wDASH",
      tokenIcon: "tokenicon_dash.svg"
    },
    /*
    {
      tokenName: "wXZC",
      tokenIcon: "tokenicon_xzc.svg"
    },
    */
  ]

  updateTokenPrice = async () => {
    try{
      let tmpData = await axios.get("https://api.coingecko.com/api/v3/simple/price?ids=apix,weth,dash&vs_currencies=usd", {})
      let tmpTokenPriceList = this.state.tokenPriceList
      tmpTokenPriceList[0] = (tmpData.data["apix"].usd).toFixed(4);
      tmpTokenPriceList[1] = (tmpData.data["weth"].usd).toFixed(4);
      tmpTokenPriceList[2] = (tmpData.data["dash"].usd).toFixed(4);
      
      //console.log(tmpTokenPriceList);

      this.setState({
        tokenPriceList: tmpTokenPriceList
      })
    } catch(err) {
      console.log(err)
    }
  }

  toggleTokenSelectbox = (id) => {
    let tmp = this.state.tokenSelectboxOpened;
    tmp[id] = !tmp[id]

    this.setState({
      tokenSelectboxOpened: tmp
    })
  }

  changeSelectedToken = (id, to) => {
    let tmp = this.state.tokenSelected;

    if(id === 0) {
      if(to === tmp[1]) {
        tmp[1] = tmp[0];
        tmp[0] = to;
      } else {
        tmp[id] = to;
      }
    }
    if(id === 1) {
      if(to === tmp[0]) {
        tmp[0] = tmp[1];
        tmp[1] = to;
      } else {
        tmp[id] = to;
      }
    }

    this.setState({
      tokenSelected: tmp
    })

    this.toggleTokenSelectbox(id);
  }

  updateTokenAmount = () => {

  }

  searchSwap = async () => {
    //new
    //1 - 0 : weth to apix (contract: apix to wdash [0]) searchedSwapPair    0
    //2 - 0 : wdash to apix  (contract: apix to wdash [1]) searchedSwapPair  1
    //0 - 1 : apix to weth (contract: apix to wdash [2]) searchedSwapPair    2
    //2 - 1 : wdash to weth (contract: apix to wdash [3]) searchedSwapPair   3
    //0 - 2 : apix to wdash  (contract: apix to wdash [4]) searchedSwapPair  4
    //1 - 2 : weth to wdash (contract: apix to wdash [5]) searchedSwapPair   5
    
    //old
    //1 - 0 : wdash to apix (contract: apix to wdash [0]) searchedSwapPair   0
    //2 - 0 : wxzc to apix  (contract: apix to wdash [1]) searchedSwapPair   1
    //0 - 1 : apix to wdash (contract: apix to wdash [2]) searchedSwapPair   2
    //2 - 1 : wxzc to wdash (contract: apix to wdash [3]) searchedSwapPair   3
    //0 - 2 : apix to wxzc  (contract: apix to wdash [4]) searchedSwapPair   4
    //1 - 2 : wdash to wxzc (contract: apix to wdash [5]) searchedSwapPair   5

    //console.log(SupportedTokens);
    //console.log(SwapContracts);
    //console.log(SwapContractABI);
    //let apix_to_wdash_contract = new this.web3.eth.Contract(SwapContractABI, SwapContracts[0].contractAddr);
    //let apix_to_wxzc_contract = new this.web3.eth.Contract(SwapContractABI, SwapContracts[1].contractAddr);

    let selectedSwapPair = 0;
    if (this.state.tokenSelected[0] === 0 && this.state.tokenSelected[1] === 1) selectedSwapPair = 0;
    if (this.state.tokenSelected[0] === 0 && this.state.tokenSelected[1] === 2) selectedSwapPair = 1;
    if (this.state.tokenSelected[0] === 1 && this.state.tokenSelected[1] === 0) selectedSwapPair = 2;
    if (this.state.tokenSelected[0] === 1 && this.state.tokenSelected[1] === 2) selectedSwapPair = 3;
    if (this.state.tokenSelected[0] === 2 && this.state.tokenSelected[1] === 0) selectedSwapPair = 4;
    if (this.state.tokenSelected[0] === 2 && this.state.tokenSelected[1] === 1) selectedSwapPair = 5;

    let selectedContract = new this.web3.eth.Contract(SwapContractABI, SwapContracts[selectedSwapPair].contractAddr);
    let swap_count = await selectedContract.methods.swapCount().call();

    let swapList = [];
    for (let i = 0; i < swap_count; i++) {
      let tmpCallData = await selectedContract.methods.SwapOrders(i).call();
      //inversion to show exact value
      let tmpVar = tmpCallData.fromTokenAmount;
      tmpCallData.fromTokenAmount = tmpCallData.toTokenAmount;
      tmpCallData.toTokenAmount = tmpVar;
      //inversion to show exact value
      swapList.push(tmpCallData);
    }

    this.setState({
      swapSearchResult: swapList,
      searchedSwapPair: selectedSwapPair
    })

    this.props.history.push('/search/' + this.tokenInfo[this.state.tokenSelected[0]].tokenName + "-" + this.tokenInfo[this.state.tokenSelected[1]].tokenName);
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.updateTokenPrice();
    this.tokenPriceInterval = setInterval(this.updateTokenPrice, 10000);

    try {
      this.web3 = new Web3(Web3.givenProvider);

      this.web3.eth.requestAccounts()
        .then((result) => {
          //console.log(result);
          this.setState({
            isMetamaskConnected: true,
            userAccount: result[0]
          })
        })
        .catch((err) => {
          this.setState({
            isMetamaskConnected: false,
            userAccount: ""
          })
        })
    } catch (err) {

    }

    let selectedSwapPair = -1;
    /*old
    if (this.props.match.params.pair === "APIX-wDASH") selectedSwapPair = 0;
    if (this.props.match.params.pair === "APIX-wXZC") selectedSwapPair = 1;
    if (this.props.match.params.pair === "wDASH-APIX") selectedSwapPair = 2;
    if (this.props.match.params.pair === "wDASH-wXZC") selectedSwapPair = 3;
    if (this.props.match.params.pair === "wXZC-APIX") selectedSwapPair = 4;
    if (this.props.match.params.pair === "wXZC-wDASH") selectedSwapPair = 5;
    */

    if (this.props.match.params.pair === "APIX-WETH") selectedSwapPair = 0;
    if (this.props.match.params.pair === "APIX-wDASH") selectedSwapPair = 1;
    if (this.props.match.params.pair === "WETH-APIX") selectedSwapPair = 2;
    if (this.props.match.params.pair === "WETH-wDASH") selectedSwapPair = 3;
    if (this.props.match.params.pair === "wDASH-APIX") selectedSwapPair = 4;
    if (this.props.match.params.pair === "wDASH-WETH") selectedSwapPair = 5;
    if (selectedSwapPair === -1) {

    } else {
      this.setState({
        selectedSwapPair
      })

      this.searchSwap();
    }
  }

  componentWillUnmount = () => {
    clearInterval(this.tokenPriceInterval);
  }

  renderButtons = (id) => {
    let buttons = [];
    for (let i = 0; i < this.tokenInfo.length; i++) {
      buttons.push(
        <div className="selectbox-button" onClick={() => { this.changeSelectedToken(id, i) }}>
          <img className="selectbox-button-icon" src={require("../../Asset/" + this.tokenInfo[i].tokenIcon)} />
          <p className="selectbox-button-text">{this.tokenInfo[i].tokenName}</p>
        </div>
      )
    }
    return buttons;
  }

  renderTokenSelectBox = (id) => {
    if (this.state.tokenSelectboxOpened[id]) {
      return (
        <div className="APIS-swapbox-selectbox">
          <div>
            <p className="selectbox-title">Select Token</p>
          </div>
          <div className="selectbox-buttons">
            {this.renderButtons(id)}
          </div>
        </div>
      )
    }
    return null;
  }

  renderSwapList = () => {
    let tmpSwapList = [];

    //provides data based on the contract. so it should be inverted in the swaporderbox component

    tmpSwapList.push(<SwapOrderBox swapPair={this.state.searchedSwapPair} swapData={null} priceData={this.state.tokenPriceList}/>)
    for (let i = (this.state.swapSearchResult.length) - 1; i >= 0; i--) {
      tmpSwapList.push(<SwapOrderBox swapPair={this.state.searchedSwapPair} swapData={this.state.swapSearchResult[i]} priceData={this.state.tokenPriceList}/>)
    }

    return tmpSwapList;
  }
  renderNewSwapList = () => {
    let tmpSwapList = [];
    //240153
    tmpSwapList.push(<SwapOrderBox swapPair={2} swapData={null} priceData={this.state.tokenPriceList}/>)
    tmpSwapList.push(<SwapOrderBox swapPair={4} swapData={null} priceData={this.state.tokenPriceList}/>)
    tmpSwapList.push(<SwapOrderBox swapPair={0} swapData={null} priceData={this.state.tokenPriceList}/>)
    tmpSwapList.push(<SwapOrderBox swapPair={1} swapData={null} priceData={this.state.tokenPriceList}/>)
    tmpSwapList.push(<SwapOrderBox swapPair={5} swapData={null} priceData={this.state.tokenPriceList}/>)
    tmpSwapList.push(<SwapOrderBox swapPair={3} swapData={null} priceData={this.state.tokenPriceList}/>)

    return tmpSwapList;
  }

  renderSwapListSection = () => {
    if (!this.state.isMetamaskConnected) {
      return null;
    }
    if (this.state.swapSearchResult.length === 0) {
      return (
        <div>
          <div className="APIS-swap-list">
            {this.renderNewSwapList()}
          </div>
        </div>
      )
    } else {
      return (
        <div>
          <div className="APIS-swap-listhead">
            <h1 className="APIS-swap-listhead-title">Swap Searched</h1>

            <p className="APIS-swap-listhead-option">Biggest Swap Amount</p>
            <p className="APIS-swap-listhead-option">Best Swap Ratio</p>
            <p className="APIS-swap-listhead-option-selected">Recent Swap</p>
          </div>
          <div className="APIS-swap-list">
            {this.renderSwapList()}
          </div>
        </div>
      )
    }
  }

  renderMetaMaskRequired = () => {
    if (!this.state.isMetamaskConnected) {
      return (
        <div>
          <div className="Metamask-required">
            <h1>Metamask Required!</h1>
            <p className="Metamask-required-text">
              Metamask is Required to use APIS Decentralized Swap.<br />
              Please install Metamask, prepare wallet with enough tokens and ETH, and use appropriate browser to use our service.<br /><br />
              Check out Metamask installation/usage guide here.
            </p>
            <a href="https://metamask.io/">https://metamask.io/</a>
          </div>
        </div>
      )
    } else {
      return null;
    }
  }

  render() {
    return (
      <div className="APIS-swap">

        <div className="APIS-swap-topdiv">
          <div className="APIS-swap-topcontent">
            <div className="APIS-swap-intro">
              <div className="APIS-swap-intro-text">
                <h1 className="APIS-swap-intro-text-head">
                  <span className="APIS-swap-intro-text-bold">Fast</span> and <span className="APIS-swap-intro-text-bold">simple</span> way<br />
                  to <span className="APIS-swap-intro-text-bold">Swap</span> APIX,
                  <span className="intro-link" onClick={()=>{window.location.href = "https://weth.io"}}> WETH</span> and
                  <span className="intro-link" onClick={()=>{window.location.href = "https://etherscan.io/token/0x29c8c00ec4d2Aac7232D4B974707b850c1c28285"}}> APIS Wrapped Tokens</span>
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="APIS-swap-centerdiv">
          <div className="APIS-swap-centercontent">
            <div className="APIS-swapbox">
              <div className="APIS-swapbox-top">
                <div className="APIS-swapbox-1">
                  <p className="APIS-swapbox-tag">From (token to send)</p>
                  <div className="APIS-swapbox-selector">

                    <div className="APIS-swapbox-selector-2">
                      <div className="APIS-swapbox-tokenselector" onClick={() => { this.toggleTokenSelectbox(0) }}>
                        <div className="tokenselector-1">
                          <img className="tokenselector-icon" src={require("../../Asset/" + this.tokenInfo[this.state.tokenSelected[0]].tokenIcon)} />
                        </div>
                        <div className="tokenselector-2">
                          <p className="tokenselector-tokenname">{this.tokenInfo[this.state.tokenSelected[0]].tokenName}</p>
                        </div>
                        <div className="tokenselector-3">
                          <img className="tokenselector-updown" src={require(this.state.tokenSelectboxOpened[0] ? "../../Asset/ic_up.svg" : "../../Asset/ic_down.svg")} />
                        </div>
                      </div>
                    </div>

                    <div className="APIS-swapbox-selector-1">
                      <input className="APIS-swapbox-input" placeholder="amount">

                      </input>
                    </div>
                  </div>
                  {this.renderTokenSelectBox(0)}
                </div>

                <div className="APIS-swapbox-2">
                  <img className="swap-icon" src={require("../../Asset/swap_icon.svg")} />
                </div>

                <div className="APIS-swapbox-3">
                  <p className="APIS-swapbox-tag">To (token to get)</p>
                  <div className="APIS-swapbox-selector">
                    <div className="APIS-swapbox-selector-2">
                      <div className="APIS-swapbox-tokenselector" onClick={() => { this.toggleTokenSelectbox(1) }}>
                        <div className="tokenselector-1">
                          <img className="tokenselector-icon" src={require("../../Asset/" + this.tokenInfo[this.state.tokenSelected[1]].tokenIcon)} />
                        </div>
                        <div className="tokenselector-2">
                          <p className="tokenselector-tokenname">{this.tokenInfo[this.state.tokenSelected[1]].tokenName}</p>
                        </div>
                        <div className="tokenselector-3">
                          <img className="tokenselector-updown" src={require(this.state.tokenSelectboxOpened[1] ? "../../Asset/ic_up.svg" : "../../Asset/ic_down.svg")} />
                        </div>
                      </div>
                    </div>
                    <div className="APIS-swapbox-selector-1">
                      <input className="APIS-swapbox-input" placeholder="amount">

                      </input>
                    </div>
                  </div>
                  {this.renderTokenSelectBox(1)}
                </div>

                <div className="APIS-swapbox-4">
                  <button className="APIS-swapbox-swapbutton" onClick={() => { this.searchSwap() }}>
                    Search Swap
                  </button>
                </div>
              </div>
              <div className="APIS-swapbox-bottom">
                <p className="APIS-swapbox-bottomtext">
                  By using the APIS Decentralized Swap service, you are agreeing to the
                  <span className="APIS-swapbox-bottomtext-tnc"> Terms and Conditions</span>
                </p>
              </div>
            </div>

            {this.renderSwapListSection()}
            {this.renderMetaMaskRequired()}
          </div>
        </div>

      </div>
    )
  }
}

export default withRouter(Home);